'use client';
import React from 'react';

const stats = [
  { value: '12,000+', label: 'Curious Readers' },
  { value: '340+', label: 'Articles Published' },
  { value: '48', label: 'Topics Covered' },
  { value: '6', label: 'Content Types' },
];

const categories = [
  { name: 'Cosmology', count: 42, icon: '🌌' },
  { name: 'Biology', count: 38, icon: '🧬' },
  { name: 'Physics', count: 51, icon: '⚛️' },
  { name: 'Philosophy', count: 29, icon: '🧠' },
  { name: 'Chemistry', count: 33, icon: '🔬' },
  { name: 'Civilization', count: 27, icon: '🏛️' },
  { name: 'Mathematics', count: 24, icon: '∞' },
  { name: 'Evolution', count: 36, icon: '🦕' },
  { name: 'Technology', count: 45, icon: '⚙️' },
  { name: 'Neuroscience', count: 31, icon: '🧪' },
  { name: 'Astronomy', count: 39, icon: '🔭' },
  { name: 'Geology', count: 22, icon: '🪨' },
];

export default function StatsAndCategories() {
  return (
    <section className="bg-[#0a0e1a] border-b border-[#1e2a3a]">
      {/* Stats Bar */}
      <div className="border-b border-[#1e2a3a]">
        <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats?.map((stat, i) => (
              <div key={i} className="text-center">
                <div
                  className="text-[#e01a2e] font-bold mb-1"
                  style={{
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: 'clamp(24px, 3vw, 36px)',
                    lineHeight: '1',
                  }}
                >
                  {stat?.value}
                </div>
                <div
                  className="text-[#a0aec0] text-[12px] uppercase tracking-widest"
                  style={{ fontFamily: 'Roboto, sans-serif' }}
                >
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Category Chips */}
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-8">
        <h2
          className="text-white font-semibold mb-5"
          style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '18px', fontWeight: 500 }}
        >
          Browse by Category
        </h2>
        <div className="flex flex-wrap gap-3">
          {categories?.map((cat, i) => (
            <a
              key={i}
              href="#topics"
              className="group flex items-center gap-2 bg-[#0d1120] border border-[#1e2a3a] hover:border-[#e01a2e] hover:bg-[#111827] px-4 py-2 rounded-sm transition-all duration-200"
            >
              <span className="text-[14px]">{cat?.icon}</span>
              <span
                className="text-[#a0aec0] group-hover:text-white text-[13px] font-medium transition-colors duration-200"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                {cat?.name}
              </span>
              <span
                className="text-[10px] text-[#4a5568] group-hover:text-[#e01a2e] transition-colors duration-200"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                {cat?.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
